import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-object-notice',
  template: `
    <div class="notice-wrapper"  [ngClass]="indicat">
      <svg
        class="main-icon"
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.5005 0C4.70069 0 5.69744e-08 4.70069 5.69744e-08 10.4995C-0.000143595 11.8784 0.271363 13.244 0.799014 14.518C1.32667 15.7921 2.10012 16.9497 3.07522 17.9248C4.05031 18.8999 5.20794 19.6733 6.48199 20.201C7.75604 20.7286 9.12155 21.0001 10.5005 21C16.2982 21 21 16.2993 21 10.4995C21 4.70069 16.2982 0 10.5005 0ZM11.4805 3.79074C12.5042 3.79074 12.805 4.38462 12.805 5.0638C12.805 5.91141 12.1269 6.69559 10.9686 6.69559C9.99964 6.69559 9.5381 6.2089 9.56653 5.40284C9.56653 4.72366 10.1342 3.79074 11.4805 3.79074ZM8.85782 16.7882C8.15786 16.7882 7.6471 16.3627 8.13598 14.498L8.93766 11.1896C9.07656 10.6602 9.09953 10.448 8.93766 10.448C8.72876 10.448 7.8199 10.8133 7.284 11.1743L6.93511 10.6023C8.6358 9.18155 10.5913 8.34816 11.428 8.34816C12.128 8.34816 12.2439 9.17499 11.895 10.448L10.9763 13.926C10.8133 14.5406 10.8833 14.7528 11.0463 14.7528C11.2563 14.7528 11.9431 14.4991 12.619 13.9665L13.0149 14.498C11.3602 16.1517 9.55669 16.7882 8.85782 16.7882Z"
        />
      </svg>
      <div class="notice">
          <svg
            class="small-icon"
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.5005 0C4.70069 0 5.69744e-08 4.70069 5.69744e-08 10.4995C-0.000143595 11.8784 0.271363 13.244 0.799014 14.518C1.32667 15.7921 2.10012 16.9497 3.07522 17.9248C4.05031 18.8999 5.20794 19.6733 6.48199 20.201C7.75604 20.7286 9.12155 21.0001 10.5005 21C16.2982 21 21 16.2993 21 10.4995C21 4.70069 16.2982 0 10.5005 0ZM11.4805 3.79074C12.5042 3.79074 12.805 4.38462 12.805 5.0638C12.805 5.91141 12.1269 6.69559 10.9686 6.69559C9.99964 6.69559 9.5381 6.2089 9.56653 5.40284C9.56653 4.72366 10.1342 3.79074 11.4805 3.79074ZM8.85782 16.7882C8.15786 16.7882 7.6471 16.3627 8.13598 14.498L8.93766 11.1896C9.07656 10.6602 9.09953 10.448 8.93766 10.448C8.72876 10.448 7.8199 10.8133 7.284 11.1743L6.93511 10.6023C8.6358 9.18155 10.5913 8.34816 11.428 8.34816C12.128 8.34816 12.2439 9.17499 11.895 10.448L10.9763 13.926C10.8133 14.5406 10.8833 14.7528 11.0463 14.7528C11.2563 14.7528 11.9431 14.4991 12.619 13.9665L13.0149 14.498C11.3602 16.1517 9.55669 16.7882 8.85782 16.7882Z"
            />
          </svg>
        {{ notice }}
      </div>
    </div>
  `,
  styles: [
    `
      .notice-wrapper {
        position: relative;
        cursor: pointer;
      }
      .RED {
        path {
          fill: #d70202;
        }
        .notice {
          border-color: #d70202;
        }
      }
      .YELLOW {
        path {
          fill: #ebaa00;
        }
        .notice {
          border-color: #ebaa00;
        }
      }
      .GREEN {
        display: none;
      }
      svg {
        &.main-icon {
          &:hover + .notice {
            display: block;
          }
        }
        &.small-icon {
          width: 13px;
          height: 13px;
        }
      }
      .notice {
        display: none;
        position: absolute;
        right: 0;
        top: 23px;
        background: #fff;
        border: 2px solid transparent;
        z-index: 99999;
        color: #000;
        padding: 15px 10px;
        font-size: 14px;
        font-weight: 700;
        border-radius: 5px;
        width: 200px;
        word-wrap: break-word;
        &:hover {
          display: block;
        }
      }
    `,
  ],
})
export class ObjectNotice {
  @Input() indicat: string;
  @Input() notice: string;
}
